// hooks/use-selection.js — SHARED SELECTION STATE
// ============================================================================
// Global hook for select mode across features (Artifacts, Playbook, etc.)
// ============================================================================
import { useState, useCallback } from 'react';

export default function useSelection() {
  const [selectMode, setSelectMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const toggleSelectMode = useCallback(() => {
    setSelectMode(prev => {
      if (prev) setSelectedItems([]);
      return !prev;
    });
  }, []);

  const toggleItem = useCallback((item) => {
    setSelectedItems(prev => {
      const exists = prev.find(i => i.id === item.id);
      return exists ? prev.filter(i => i.id !== item.id) : [...prev, item];
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectMode(false);
    setSelectedItems([]);
  }, []);

  const isSelected = useCallback((id) => {
    return selectedItems.some(i => i.id === id);
  }, [selectedItems]);

  return { selectMode, selectedItems, toggleSelectMode, toggleItem, clearSelection, isSelected };
}
